import React, { useCallback, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import InvoiceForm from './InvoicesForm';
import { ChangeHighlighter, FormattedNumberInput, Loading } from '@rd-web-markets/shared/dist/util';
import { isValueDefined } from '@rd-web-markets/shared/dist/util/helpers/is_value_defined';
import financialYearsService from '../../services/financial_years.service';
import offerInvoicesService from '../../services/offer_invoices.service';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import { useTranslation } from 'react-i18next';
import projectContractorsService from '@rd-web-markets/de/dist/services/project_contractor.service';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
const FinancialYear = _ref => {
  let {
    financialYear,
    detail,
    loading,
    setSelectedContractor,
    contractor,
    applicationSubmitted
  } = _ref;
  const [currentFinancialYear, setCurrentFinancialYear] = useState(null);
  const {
    t
  } = useTranslation();
  useEffect(() => {
    setCurrentFinancialYear(financialYear);
  }, [contractor, setCurrentFinancialYear, financialYear]);
  const handleFinancialYearChange = async event => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    setCurrentFinancialYear({
      ...currentFinancialYear,
      [event.target.name]: value
    });
  };
  const saveFinancialYearChange = useErrorHandling(useCallback(async () => {
    const updatedFinancialYear = await financialYearsService.update(detail.id, currentFinancialYear);
    const updatedContractor = await projectContractorsService.get(contractor.claim_project_report_id, contractor.id);
    setSelectedContractor(updatedContractor);
    //setCurrentFinancialYear(updatedFinancialYear);
  }, [contractor.claim_project_report_id, contractor.id, currentFinancialYear, detail, setSelectedContractor]));
  const toggleIncludeInTotal = useErrorHandling(useCallback(async e => {
    const updatedFinancialYear = await financialYearsService.update(detail.id, {
      ...currentFinancialYear,
      include_in_total: e.target.checked
    });
    const updatedContractor = await projectContractorsService.get(contractor.claim_project_report_id, contractor.id);
    setSelectedContractor(updatedContractor);
    //setCurrentFinancialYear(updatedFinancialYear);
  }, [contractor.claim_project_report_id, contractor.id, currentFinancialYear, detail, setSelectedContractor]));
  const addOfferInvoice = useErrorHandling(useCallback(async currentFinancialYear => {
    const offerInvoice = await offerInvoicesService.create(currentFinancialYear.id, {
      include_in_total: false
    });
    const newInvoices = currentFinancialYear.offer_invoices;
    newInvoices.push(offerInvoice);
    setCurrentFinancialYear({
      ...currentFinancialYear,
      offer_invoices: newInvoices
    });
  }, []));
  const handleOfferInvoiceChange = (offerInvoice, index) => {
    currentFinancialYear.offer_invoices[index] = offerInvoice;
    setCurrentFinancialYear({
      ...currentFinancialYear,
      offer_invoices: currentFinancialYear.offer_invoices
    });
  };
  const deleteOfferInvoice = useErrorHandling(useCallback(async id => {
    await offerInvoicesService.delete(currentFinancialYear.id, id);
    const updatedContractor = await projectContractorsService.get(contractor.claim_project_report_id, contractor.id);
    setSelectedContractor(updatedContractor);
  }, [contractor.claim_project_report_id, contractor.id, currentFinancialYear, setSelectedContractor]));
  if (!currentFinancialYear) return /*#__PURE__*/React.createElement(Loading, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement(ChangeHighlighter, {
    as: FormattedNumberInput,
    thousandSeparator: ".",
    decimalSeparator: ",",
    onChange: handleFinancialYearChange,
    onBlur: saveFinancialYearChange,
    object: currentFinancialYear,
    name: "cost",
    type: "text",
    size: "sm",
    className: "me-4",
    disabled: applicationSubmitted,
    onlyPositiveNumbers: true
  }), /*#__PURE__*/React.createElement(Form.Check, {
    checked: currentFinancialYear.include_in_total && isValueDefined(currentFinancialYear.cost),
    value: !!currentFinancialYear.include_in_total,
    name: "include_in_total",
    onChange: toggleIncludeInTotal,
    disabled: !isValueDefined(currentFinancialYear.cost) || applicationSubmitted
  })), detail.cost_type === 'offer' && currentFinancialYear.offer_invoices.sort((a, b) => a.id - b.id).map((offerInvoice, index) => {
    return /*#__PURE__*/React.createElement(InvoiceForm, {
      applicationSubmitted: applicationSubmitted,
      key: index,
      invoiceIndex: index,
      setSelectedContractor: setSelectedContractor,
      contractor: contractor,
      financialYear: currentFinancialYear,
      loading: loading,
      offerInvoice: offerInvoice,
      deleteOfferInvoice: deleteOfferInvoice,
      handleOfferInvoiceChange: handleOfferInvoiceChange
    });
  }), detail.cost_type === 'offer' && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    onClick: () => addOfferInvoice(currentFinancialYear),
    type: "primary",
    icon: /*#__PURE__*/React.createElement("span", {
      className: "material-icons md-18"
    }, "add"),
    loading: loading,
    disabled: applicationSubmitted
  }, t('add_invoice'))));
};
export default FinancialYear;